

// import React from "react";
// import { useTranslation } from "react-i18next";

// const ModificationRequestDetails = ({ request, onBack, onDecision }) => {
//   const { t, i18n } = useTranslation();
//   const getName = (item) =>
//   i18n.language === "ar"
//     ? item.product_name_arabic || item.product_name_english
//     : item.product_name_english || item.product_name_arabic;

//   if (!request) return null;

//   const originalItems = request.original_items || [];
//   const modifiedItems = request.modified_items || [];
//   const formatNumber = (value) => {
//   return new Intl.NumberFormat(
//     i18n.language === "ar" ? "ar-QA" : "en-US"
//   ).format(value);
// };

// const formatCurrency = (value) => {
//   return new Intl.NumberFormat(
//     i18n.language === "ar" ? "ar-QA" : "en-US",
//     {
//       style: "currency",
//       currency: "QAR",
//       minimumFractionDigits: 2,
//     }
//   ).format(value);
// };

// const formatOrderId = (id) => {
//   if (i18n.language !== "ar") return id;

//   return id.replace(/\d/g, (d) =>
//     new Intl.NumberFormat("ar-QA").format(d)
//   );
// };

//   return (
//     <div className="dashboard_page">
//       {/* HEADER */}
//       <div className="page_header">
//         <h2>{t("resmodification_request")}</h2>

//         <button className="btn_add_item_v2" onClick={onBack}>
//           <i className="fa fa-arrow-left me-2"></i>
//           {t("resback")}
//         </button>
//       </div>

//       {/* SUMMARY */}
//       <div className="card order_summary">
//         <div className="summary_left">
//           <p>
//             <b>{t("resorder_id")}:</b> 
//             <span dir="ltr" style={{ unicodeBidi: "isolate" }}>
//                 {formatOrderId(request.order_id)}
//             </span>
//           </p>

//           <p>
//             <b>{t("resreason")}:</b> {request.note}
//           </p>

//           <span className="status_badge warning">
//             {t("respending_approval")}
//           </span>
//         </div>

//         <div className="summary_right">
//           <span>{t("resbefore")}</span>
//           <h4>
//             {t("resqar")} {formatCurrency(request.total_before)}
//           </h4>

//           <span className="mt-2 d-block">{t("resafter")}</span>

//           <h3
//             className={
//               request.total_after < request.total_before
//                 ? "text-danger"
//                 : "text-success"
//             }
//           >
//             {t("resqar")} {formatCurrency(request.total_after)}
//           </h3>
//         </div>
//       </div>

//       {/* ITEMS COMPARISON */}
//       <div className="row mt-4">
//         {/* ORIGINAL */}
//         <div className="col-md-6">
//           <div className="card">
//             <h5 className="card_title">{t("resoriginal_items")}</h5>

//             <table className="table order_table">
//               <thead>
//                 <tr>
//                   <th>{t("resitem")}</th>
//                   <th>{t("resqty")}</th>
//                   <th className="text-end">{t("resprice")}</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {originalItems.map((i, idx) => (
//                   <tr key={idx}>
//                     <td>{getName(i)}</td>

//                     <td>{formatNumber(i.quantity)}</td>

//                     <td className="text-end">
//                        {formatCurrency(i.price_per_unit)}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* MODIFIED */}
//         <div className="col-md-6">
//           <div className="card">
//             <h5 className="card_title">{t("resmodified_items")}</h5>

//             <table className="table order_table">
//               <thead>
//                 <tr>
//                   <th>{t("resitem")}</th>
//                   <th>{t("resqty")}</th>
//                   <th className="text-end">{t("resprice")}</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {modifiedItems.map((i, idx) => {
//                   const oldQty = originalItems[idx]?.quantity;
//                   const qtyChanged = oldQty !== i.quantity;

//                   return (
//                     <tr key={idx}>
//                       <td>
//                         {i18n.language === "ar"
//                           ? i.product_name_arabic || i.product_name_english
//                           : i.product_name_english}
//                       </td>

//                       <td className={qtyChanged ? "text-danger fw-bold" : ""}>
//                         {formatNumber(i.quantity)}
//                       </td>

//                       <td className="text-end">
//                          {formatCurrency(i.price_per_unit)}
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>

//       {/* ACTION BAR */}
//       <div className="cta_bar">
//         <button
//           className="btn btn-outline-danger btn-lg"
//           onClick={() => onDecision(request.id, "REJECTED")}
//         >
//           {t("resreject_changes")}
//         </button>

//         <button
//           className="btn btn-success btn-lg"
//           onClick={() => onDecision(request.id, "APPROVED")}
//         >
//           {t("resaccept_changes")}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ModificationRequestDetails;







import React from "react";
import { useTranslation } from "react-i18next";

const ModificationRequestDetails = ({ request, onBack, onDecision }) => {
  const { t, i18n } = useTranslation();
  const getName = (item) =>
  i18n.language === "ar"
    ? item.product_name_arabic || item.product_name_english
    : item.product_name_english || item.product_name_arabic;

  if (!request) return null;

  const originalItems = request.original_items || [];
  const modifiedItems = request.modified_items || [];
  const formatNumber = (value) => {
  return new Intl.NumberFormat(
    i18n.language === "ar" ? "ar-QA" : "en-US"
  ).format(value);
};

const amountDifference =
  Math.abs(request.total_before - request.total_after);

const percentageChange =
  request.total_before > 0
    ? ((amountDifference / request.total_before) * 100).toFixed(2)
    : 0;

const originalTotal = originalItems.reduce(
  (sum, item) => sum + item.quantity * item.price_per_unit,
  0
);

const modifiedTotal = modifiedItems.reduce(
  (sum, item) => sum + item.quantity * item.price_per_unit,
  0
);

const formatCurrency = (value) => {
  return new Intl.NumberFormat(
    i18n.language === "ar" ? "ar-QA" : "en-US",
    {
      style: "currency",
      currency: "QAR",
      minimumFractionDigits: 2,
    }
  ).format(value);
};

const formatOrderId = (id) => {
  if (i18n.language !== "ar") return id;

  return id.replace(/\d/g, (d) =>
    new Intl.NumberFormat("ar-QA").format(d)
  );
};

  return (
    <div className="dashboard_page">
      {/* HEADER */}
      <div className="page_header">
        <h2>{t("resmodification_request")}</h2>

        <button className="btn_add_item_v2" onClick={onBack}>
          <i className="fa fa-arrow-left me-2"></i>
          {t("resback")}
        </button>
      </div>

      {/* SUMMARY */}
      {/* <div className="card order_summary">
        <div className="summary_left">
          <p>
            <b>{t("resorder_id")}:</b> 
            <span dir="ltr" style={{ unicodeBidi: "isolate" }}>
                {formatOrderId(request.order_id)}
            </span>
          </p>

          <p>
            <b>{t("resreason")}:</b> {request.note}
          </p>

          <span className="status_badge warning">
            {t("respending_approval")}
          </span>
        </div>

        <div className="summary_right">
          <span>{t("resbefore")}</span>
          <h4>
            {t("resqar")} {formatCurrency(request.total_before)}
          </h4>

          <span className="mt-2 d-block">{t("resafter")}</span>

          <h3
            className={
              request.total_after < request.total_before
                ? "text-danger"
                : "text-success"
            }
          >
            {t("resqar")} {formatCurrency(request.total_after)}
          </h3>
        </div>
      </div> */}


     
      <div className="card order_summary modern_order_summary">

        {/* LEFT ICON */}
        <div className="order_summary_icon">
          <i className="fas fa-clipboard-list"></i>
        </div>

        {/* CENTER DETAILS */}
        <div className="order_summary_details">

          <div className="summary_item">
            <i className="far fa-file-alt"></i>
            <div>
              <span>{t("resorder_id")}</span>
              <h6 dir="ltr" style={{ unicodeBidi: "isolate" }}>
		{formatOrderId(request.order_id)}
		</h6>
            </div>
          </div>

          <div className="summary_item">
            <i className="far fa-calendar-alt"></i>
            <div>
              <span>{t("resreason")}</span>
              <h6>{request.note}</h6>
            </div>
          </div>

          <div className="summary_item">
            <i className="fa fa-hourglass-half"></i>
            <div>
              {/* <span>{t("ressupplier")}</span> */}
              <h6  className="status_badge warning">
                {t("respending_approval")}
              </h6>
            </div>
          </div>

          

        </div>

        {/* DIVIDER */}
        <div className="summary_divider"></div>

        {/* RIGHT AMOUNT */}
        {/* <div className="order_summary_amount">

          <p>{t("restotal_amount")}</p>

          
          <div className="amount_card">
        <div className="amount_icon">
          <i className="fas fa-coins"></i>
        </div>

        <div>
          <h3>{formatCurrency(request.total_after)}</h3>
        </div>
      </div>

        </div> */}

        <div className="order_summary_amount">

  <div className="comparison_wrapper">

    <div className="price_box before_box">
      <span>{t("resbefore")}</span>
      <h4>{formatCurrency(request.total_before)}</h4>
    </div>

    <div className="comparison_arrow">
      <i className="fas fa-arrow-right"></i>
    </div>

    <div className="price_box after_box">
      <span>{t("resafter")}</span>
      <h4>{formatCurrency(request.total_after)}</h4>
    </div>

  </div>

  <div className="change_summary">

    <div className="change_left">
      <i className="fas fa-chart-line"></i>

      <div>
        <span>Discount</span>
        <h4>{formatCurrency(amountDifference)}</h4>
      </div>
    </div>

    <div className="change_right">
      <i className="fas fa-arrow-down"></i>
      {percentageChange}%
    </div>

  </div>

</div>


      </div>

      {/* ITEMS COMPARISON */}
      <div className="row mt-4">
        {/* ORIGINAL */}
        <div className="col-md-6">
          <div className="card">
            <div class="grn-info-item detail-row">
              <div class="grn-info-icon supplier">
                <i class="fas fa-cube"></i>
              </div>
              <div class="grn-info-content">
                <div class="grn-info-value">{t("resoriginal_items")}
                </div>
              </div>
            </div>

            <table className="table order_table">
              <thead>
                <tr>
                  <th>{t("resitem")}</th>
                  <th>{t("resqty")}</th>
                  <th className="text-end">{t("resprice")}</th>
                  
                </tr>
              </thead>

              <tbody>
                {originalItems.map((i, idx) => (
                  <tr key={idx}>
                    <td>{getName(i)}</td>

                    <td>{formatNumber(i.quantity)}</td>

                    <td className="text-end">
                       {formatCurrency(i.price_per_unit)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="table_footer_summary original">

            <div class="grn-info-item ">
              <div class="grn-info-icon user">
                <i class="fas fa-cubes"></i>
              </div>
              <div class="grn-info-content">
                <div class="grn-info-value">
		            <span>Total Items</span>
              <h3 id="modifcation">{originalItems.length}</h3>
                </div>
              </div>
            </div>

            <div>
              <span>Total Amount</span>
              <h3 id="modifcation">{formatCurrency(originalTotal)}</h3>
            </div>

          </div>
          </div>
        </div>

        {/* MODIFIED */}
        <div className="col-md-6">
          <div className="card">
           <div class="grn-info-item detail-row">
              <div class="grn-info-icon user">
                <i class="fas fa-cubes"></i>
              </div>
              <div class="grn-info-content">
                <div class="grn-info-value">{t("resmodified_items")}
                </div>
              </div>
            </div>

            <table className="table order_table">
              <thead>
                <tr>
                  <th>{t("resitem")}</th>
                  <th>{t("resqty")}</th>
                  <th className="text-end">{t("resprice")}</th>
                </tr>
              </thead>

              <tbody>
                {modifiedItems.map((i, idx) => {
                  const oldQty = originalItems[idx]?.quantity;
                  const qtyChanged = oldQty !== i.quantity;

                  return (
                    <tr key={idx}>
                      <td>
                        {i18n.language === "ar"
                          ? i.product_name_arabic || i.product_name_english
                          : i.product_name_english}
                      </td>

                      <td className={qtyChanged ? "text-danger fw-bold" : ""}>
                        {formatNumber(i.quantity)}
                      </td>

                      <td className="text-end">
                         {formatCurrency(i.price_per_unit)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className="table_footer_summary modified">
            <div class="grn-info-item ">
              <div class="grn-info-icon supplier">
                <i class="fas fa-cubes"></i>
              </div>
              <div class="grn-info-content">
                <div class="grn-info-value">
		            <span>Total Items</span><br></br>
              <h3 id="modifcation1">{modifiedItems.length}</h3>
                </div>
              </div>
            </div>

            <div>
              <span>Total Amount</span>
              <h3 id="modifcation1">{formatCurrency(modifiedTotal)}</h3>
            </div>

          </div>
          </div>
        </div>
      </div>

      {/* ACTION BAR */}
      <div className="cta_bar">
        <button
          className="btn btn-outline-danger btn-lg"
          onClick={() => onDecision(request.id, "REJECTED")}
        >
          {t("resreject_changes")}
        </button>

        <button
          className="btn btn-success btn-lg"
          onClick={() => onDecision(request.id, "APPROVED")}
        >
          {t("resaccept_changes")}
        </button>
      </div>
    </div>
  );
};

export default ModificationRequestDetails;